import { render, staticRenderFns } from "./LotMyMaxBid.vue?vue&type=template&id=28010bc8&scoped=true"
import script from "./LotMyMaxBid.vue?vue&type=script&lang=js"
export * from "./LotMyMaxBid.vue?vue&type=script&lang=js"
import style0 from "./LotMyMaxBid.vue?vue&type=style&index=0&id=28010bc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28010bc8",
  null
  
)

export default component.exports